import React, { useContext, useEffect } from 'react';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import { ChatMessage, Text, Button, Flex } from 'pcln-design-system';
import MessageFooter from '../MessageFooter/MessageFooter';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { mapManager } from '../Maps/googleMapManager';
import { MapIcon } from '../Maps/SinglePinIcon';
export const TextWithInlineMetadataComponent = React.memo(props => {
  const {
    displayableInlineContents,
    metadataCollection
  } = props;
  const {
    appendNewPinToList,
    setOpenedMap
  } = useContext(ChatbotDataContext);
  useEffect(() => {
    appendNewPinToList({
      listOfPins: metadataCollection
    });
  }, []);
  return React.createElement(ChatMessage, {
    ml: '',
    mb: 4,
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: displayableInlineContents.map((content, ci) => {
      if (Array.isArray(content)) {
        return React.createElement(React.Fragment, {
          key: `array-content-${ci}`
        }, React.createElement(Text, {
          mb: 1
        }, content.map((c, cii) => {
          var _a;
          if (typeof c === 'string') {
            return React.createElement(React.Fragment, {
              key: `meta-content-${cii}`
            }, React.createElement(Text.span, {
              mb: 1
            }, c));
          } else if (c === null || c === void 0 ? void 0 : c.metadata) {
            return React.createElement(React.Fragment, {
              key: `meta-content-${cii}`
            }, React.createElement(Button, {
              variation: 'link',
              style: {
                transform: 'translateY(5px)'
              },
              onClick: function () {
                setOpenedMap(true);
                mapManager.addCallback(() => {
                  mapManager.fitBoundsOnCurrentMap([c === null || c === void 0 ? void 0 : c.metadata]).catch(() => {});
                });
              }
            }, React.createElement(Flex, {
              alignItems: 'center'
            }, MapIcon({
              type: (_a = c.metadata) === null || _a === void 0 ? void 0 : _a.type,
              iconProp: {
                color: 'primary',
                size: 20
              }
            }), React.createElement(Text.span, {
              fontSize: 2,
              ml: 1
            }, c.metadata.name))));
          }
        })));
      } else if (content) {
        return React.createElement(React.Fragment, {
          key: `text-content-${ci}`
        }, React.createElement(Text, {
          mb: 1
        }, content));
      }
    }),
    footer: React.createElement(MessageFooter, null)
  });
});